import styled from "styled-components";

import { colourHierarchy } from "./StyledHelper";

export const A = styled.a`
    color: ${props => (props.color ? props.color : colourHierarchy(props))} !important;
    font-weight: ${props => (props.bold ? "bold" : "normal")};
    font-size: ${props => props.fontSize || "inherit"};
    cursor: pointer;
    && {
        text-decoration: ${props => (props.underline ? "underline" : "none")};
    }
`;
